import React from 'react'
import ReactDOM from 'react-dom'
import { Router, browserHistory } from 'react-router'
import PiwikReactRouter from 'piwik-react-router'

import 'bootstrap/dist/css/bootstrap.css'
import './index.css';

import routes from './system/routes';

const piwik = PiwikReactRouter({
  url: 'https://matomo.troistudio.com',
  siteId: 1
})
piwik.track(window.location)

ReactDOM.render(
  <Router routes={routes}
          history={piwik.connectToHistory(browserHistory)} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js